import { z } from 'zod';
import { WorkflowTypeEnum } from './enum';

export const schemaChoiceItem = z.object({
  uid: z.string(),
  value: z.string(),
});

export const schemaWorkflowItem = z.object({
  uid: z.string(),
  workflowType: WorkflowTypeEnum,
  content: z.string().or(z.array(z.string())),
  isRequired: z.boolean(),
  choices: z.optional(z.array(schemaChoiceItem)),
  hasOtherChoice: z.boolean(),
});
